import { z } from 'zod'

export const AdditionalSupplyChainActorSchema = z.object({
  id: z.number().nullable(),
  deleted: z.boolean().optional(),
  sequenceNumber: z.number().nonnegative(),
  role: z.string(),
  identificationNumber: z.string(),
})

export type AdditionalSupplyChainActor = z.infer<typeof AdditionalSupplyChainActorSchema>
